import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { BaseService } from '../../../../../../../shared/services/base.service';
import { Utility } from '../../../../../../../common/utility';
import { GroupTemplateUrl } from '../../../../../../../shared/urls/group-template.url';

@Injectable()
export class AttachmentInfoService {
    constructor(public baseService: BaseService) { }

    getAttachments(groupId){
        const url = Utility.stringFormat(GroupTemplateUrl.GROUP_TEMPLATE_ATTACHMENT_GET, [groupId]);
        return this.baseService.getData(url);
    }

    saveAttachment(groupId, formData: FormData) {
        const url = Utility.stringFormat(GroupTemplateUrl.GROUP_TEMPLATE_ATTACHMENT_UPLOAD, [groupId]);
        return this.baseService.upload(url, formData);
    }

    removeAttachment(groupId, id) {
        const url = Utility.stringFormat(GroupTemplateUrl.GROUP_TEMPLATE_ATTACHMENT_REMOVE, [groupId, id]);
        return this.baseService.delete(url);
    }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation/waiting-room/group-template/group-template-information-popup/group-template-information/attachment-info/attachment-info.service.ts